import React from "react";
import { SharedPagination } from "../shared";

/**
 * Dashboard Pagination Component
 * Wrapper around SharedPagination with dashboard-specific styling
 */
export default function Pagination({
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  isLoading = false,
  position = "top",
}) {
  return (
    <SharedPagination
      currentPage={currentPage}
      totalPages={totalPages}
      totalCount={totalCount}
      pageSize={pageSize}
      onPageChange={onPageChange}
      isLoading={isLoading}
      position={position}
      variant="dashboard"
    />
  );
}
